import { cn } from "@/lib/utils";

export function ProductFrame({ children, className, title }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.06] to-transparent shadow-2xl",
        className,
      )}
    >
      <div className="flex items-center gap-2 border-b border-white/[0.06] px-4 py-3">
        <div className="flex gap-1.5">
          <div className="h-2.5 w-2.5 rounded-full bg-white/10" />
          <div className="h-2.5 w-2.5 rounded-full bg-white/10" />
          <div className="h-2.5 w-2.5 rounded-full bg-white/10" />
        </div>
        {title ? (
          <span className="ml-3 text-xs text-muted-foreground font-mono">{title}</span>
        ) : null}
      </div>
      <div className="relative">
        {children}
        <div className="pointer-events-none absolute inset-0 radar-grid opacity-30" />
      </div>
    </div>
  );
}
